/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 10:04:26 
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2021-12-29 14:45:20
 */
<template>
  <div>
    <span v-if="!showTip">{{ text }}</span>
    <template v-else>
      <el-tooltip
        :content="text"
        popper-class="tip-max"
        effect="dark"
        placement="top"
      >
        <span>{{ tip }}</span>
      </el-tooltip>
    </template>
  </div>
</template>
<script>
import { Tooltip } from "element-ui";
export default {
  name: "TextTip",
  components: {
    [Tooltip.name]: Tooltip,
  },
  props: {
    text: String,
    max: {
      type: Number,
      default: 12,
    },
    width: {
      type: Number,
      default: 0,
    },
    suffix: {
      type: Boolean,
      default: false,
    },
    fontSize: {
      type: Number,
      default: 12,
    },
    fontFamily: {
      type: String,
      default: "Avenir, Helvetica, Arial, sans-serif",
    },
  },
  data() {
    return {
      tip: "",
      showTip: false,
    };
  },
  watch: {
    text: {
      immediate: true,
      handler() {
        this.subStr();
      },
    },
  },
  methods: {
    subStr() {
      if (this.width > 0) {
        return this.calcWidth();
      }
      this.showTip = false;
      const title = this.text + "";
      if (!title) return title;
      const len = this.max;
      const [start, end] = this.getBase();
      if (start.length > len) {
        this.showTip = true;
        this.tip = start.substr(0, len) + "...." + end;
      }
    },
    calcWidth() {
      const [start, end] = this.getBase();
      var c = document.createElement("canvas");
      var ctx = c.getContext("2d");
      ctx.font = `${this.fontSize}px ${this.fontFamily}`;
      const realWidth = ctx.measureText(this.text).width;
      if (realWidth > this.width) {
        var text = "";
        for (let i = 0; i < start.length; i++) {
          const size = ctx.measureText(text + "...." + end).width - this.width;
          if (size >= 0) {
            if (size >= this.fontSize / 2) {
              text = text.substr(0, text.length - 1);
            }
            text += "...." + end;
            break;
          }
          text = text + start[i];
        }
        this.showTip = true;
        this.tip = text;
      } else {
        this.tip = this.text;
      }
    },
    getBase() {
      const title = this.text + "";
      let base = [title, ""];
      if (this.suffix) {
        base = title.split(".");
        if (base.length > 1) {
          const last = base.pop();
          base = [base.join(""), last];
        }
      }
      return base;
    },
  },
};
</script>